import { Flex, StackProps } from "@chakra-ui/react";
import * as React from "react";

export const PageContainer = (props: StackProps) => (
  <Flex h="100vh" overflow={"hidden"} direction={"column"} {...props}></Flex>
);
